function hamburger(toggledbutton, toggledMenu){
    const getButton = document.querySelector(toggledbutton);
    const getMenu = document.querySelector(toggledMenu);

    function toogleHam(){
        getButton.classList.toggle('hamburger_active');
        getMenu.classList.toggle('menu_active');
        document.body.classList.toggle('ow-hidden');
    }

    getButton.addEventListener('click', toogleHam, false);
    
    getMenu.querySelectorAll('a').forEach(function(element){
        if(window.innerWidth < 1024){
            console.log('qwe');
            element.addEventListener('click', toogleHam, false);
        }
    });
}

module.exports = hamburger;